import PropTypes from "prop-types";
import { Drawer, Button, Space, Upload, Alert } from "antd";
import { CloseCircleOutlined } from "@ant-design/icons";
import NoMessageIcon from "../../assets/img/svg/xnomessageicon.svg";
import NoDataFoundIcon from "../../assets/img/svg/xnodatafound.svg";
import BookCoverImage1 from "../../assets/img/png/xbookcoverimage1.png";
import FileUploadIcon from "../../assets/img/svg/xfileuploadicon.svg?react";
import AlertIcon from "../../assets/img/svg/xalert-error-icon.svg?react";

const fileList = [
  { uid: "0", name: "xxx.png", status: "uploading", percent: 33 },
  { uid: "1", name: "yyy.png", status: "done" },
  { uid: "-2", name: "zzz.png", status: "error" },
];

const formatDate = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

const formatTime = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  return `${hours}:${minutes}`;
};

const truncateTitleByWords = (title, maxWords = 6) => {
  const normalizedTitle = String(title || "").trim();
  if (!normalizedTitle) {
    return { text: "", isTruncated: false };
  }

  const words = normalizedTitle.split(/\s+/);
  if (words.length <= maxWords) {
    return { text: normalizedTitle, isTruncated: false };
  }

  return {
    text: `${words.slice(0, maxWords).join(" ")}...`,
    isTruncated: true,
  };
};

const NoDataBlock = () => (
  <div className="modal-booktitle-no-data">
    <img src={NoDataFoundIcon} alt="No data" />
    <h4>Currently No Data Available</h4>
    <h3>
      <span>
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_2654_34957)">
            <circle
              opacity="0.5"
              cx="7.99967"
              cy="8"
              r="6.66667"
              stroke="#009DDB"
              strokeWidth="1.2"
            />
            <path
              d="M8 11.3333V7.33334"
              stroke="#0009E2"
              strokeWidth="1.2"
              strokeLinecap="round"
            />
            <circle
              cx="0.666667"
              cy="0.666667"
              r="0.666667"
              transform="matrix(1 0 0 -1 7.33301 6)"
              fill="#0009E2"
            />
          </g>
          <defs>
            <clipPath id="clip0_2654_34957">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </span>{" "}
      Kindly <span className="semiBold">Scan the ISBN</span> to populate the
      data
    </h3>
  </div>
);

const SliderUI = (props) => {
  const handleIsbnKeyPress = (e) => {
    if (e.key !== "Enter") return;
    e.preventDefault();
    document.querySelector(".comments-send-button")?.click();
  };

  const renderFileUpload = () => (
    <div className="fileupload-container">
      <Upload
        action="https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload"
        listType="picture"
        defaultFileList={fileList}
        multiple
      >
        <Button type="primary" icon={<FileUploadIcon />}>
          Upload File <span className="linkClass">Choose File</span>
        </Button>
        <div className="fileupload-container-footer-text">
          <p>6 MB Max | Supported File Type : PDF/ PNG/JPG/JPEG</p>
          <p>{fileList.length} Files Selected</p>
        </div>
      </Upload>
    </div>
  );

  const renderBodyContent = () => {
    if (props.mode === "batch") {
      return props.batchData?.length > 0 ? (
        props.batchData.map((item) => {
          const fullTitle = item.title || "The Story Of A Lonely Boy";
          const truncatedTitle = truncateTitleByWords(fullTitle, 6);

          return (
            <div
              className="model-book-list-card-container"
              key={item.bid || item.isbn}
            >
              <div className="model-book-list-card">
                <div className="model-book-list-card-icon">
                  <img
                    src={item.bookCoverImageURL || BookCoverImage1}
                    alt="Book Cover"
                  />
                </div>
                <div className="model-book-list-card-details">
                  <h5 title={truncatedTitle.isTruncated ? fullTitle : undefined}>
                    {truncatedTitle.text}
                  </h5>
                  <div className="model-book-list-card-number">
                    <p>
                      BID :
                      <span className="semiBold">
                        {item.bid || "5423780912"}
                      </span>
                    </p>
                    <p>
                      ISBN :
                      <span className="semiBold">
                        {item.isbn || "9423780912"}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          );
        })
      ) : (
        <NoDataBlock />
      );
    }

    if (!props.bookscover) {
      return (
        <div className="modal-comments-content">
          <div className="modal-comments-body">
            <div className="modal-comments-card-content">
              {props.commentsList?.length > 0 ? (
                props.commentsList.map((comment, idx) => (
                  <div
                    key={idx}
                    className={`modal-comments-card ${
                      idx % 2 === 0 ? "active-messager" : "another-messager"
                    }`}
                  >
                    <div className="modal-comments-card-icon-background" />
                    <div
                      className="modal-comments-card-cutoff"
                      style={{
                        backgroundColor:
                          idx % 2 === 0 ? "#E6EDFF" : "#FFF7EF",
                      }}
                    />
                    <div
                      className="modal-comments-card-text"
                      style={{
                        backgroundColor:
                          idx % 2 === 0 ? "#E6EDFF" : "#FFF7EF",
                      }}
                    >
                      <h4>{comment?.userName}</h4>
                      <p className="overflow-paragraph">{comment?.comments}</p>
                      <div className="modal-comments-card-timestamp">
                        <span>{formatDate(comment?.createdOn)}</span>
                        <span>{formatTime(comment?.createdOn)}</span>
                      </div>
                    </div>
                    <div className="modal-comments-card-icon">B</div>
                  </div>
                ))
              ) : props.fileUpload ? (
                renderFileUpload()
              ) : (
                <div className="modal-comments-no-content">
                  <img src={NoMessageIcon} alt="No Message" />
                </div>
              )}
            </div>
          </div>

          <div className="modal-comments-footer">
            <div className="comments-input-container">
              <input
                type="text"
                className="comments-input"
                placeholder="Enter Your Comments"
                value={props?.form?.comments}
                onChange={(e) =>
                  props?.setForm((prev) => ({
                    ...prev,
                    comments: e.target.value,
                  }))
                }
                disabled={props.load}
                onKeyPress={handleIsbnKeyPress}
              />
              <button
                className="comments-send-button"
                onClick={props?.saveComment}
                disabled={props.load}
              >
                <svg
                  width="16"
                  height="17"
                  viewBox="0 0 16 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.112811 3.4701C-0.145856 2.7621 0.0488106 1.9781 0.609477 1.47343C1.16881 0.970762 1.96548 0.857429 2.64148 1.1861L14.7015 6.81543C15.3481 7.1181 15.8108 7.67076 15.9981 8.33076H2.69681L0.150811 3.55476C0.136811 3.52743 0.124144 3.49876 0.112811 3.4701ZM2.70614 9.66476L0.204144 14.4481C0.190144 14.4748 0.178144 14.5014 0.168144 14.5294C-0.0898561 15.2381 0.106811 16.0208 0.667477 16.5248C1.01481 16.8361 1.45348 16.9968 1.89481 16.9968C2.16748 16.9968 2.44081 16.9354 2.69548 16.8108L14.7028 11.1854C15.3515 10.8814 15.8135 10.3268 15.9995 9.66543H2.70614V9.66476Z"
                    fill="url(#paint0_linear_875_18440)"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_875_18440"
                      x1="16.4795"
                      y1="8.95419"
                      x2="-0.0556586"
                      y2="10.6722"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#033D9B" />
                      <stop offset="1" stopColor="#29ACD5" />
                    </linearGradient>
                  </defs>
                </svg>
              </button>
            </div>
          </div>
        </div>
      );
    }

    if (props.mode === "batch") {
      return props.batchData?.length > 0 ? (
        props.batchData.map((item) => {
          const fullTitle = item.title || "The Story Of A Lonely Boy";
          const truncatedTitle = truncateTitleByWords(fullTitle, 6);

          return (
            <div
              className="model-book-list-card-container"
              key={item.bid || item.isbn}
            >
              <div className="model-book-list-card">
                <div className="model-book-list-card-icon">
                  <img
                    src={item.bookCoverImageURL || BookCoverImage1}
                    alt="Book Cover"
                  />
                </div>
                <div className="model-book-list-card-details">
                  <h5 title={truncatedTitle.isTruncated ? fullTitle : undefined}>
                    {truncatedTitle.text}
                  </h5>
                  <div className="model-book-list-card-number">
                    <p>
                      BID :{" "}
                      <span className="semiBold">
                        {item.bid || "5423780912"}
                      </span>
                    </p>
                    <p>
                      ISBN :{" "}
                      <span className="semiBold">
                        {item.isbn || "9423780912"}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          );
        })
      ) : (
        <NoDataBlock />
      );
    }

    if (props.fileUpload === true) {
      return (
        <div>
          <div className="mb-4">
            <Alert
              message="Alert Message"
              description="There is a difference of 05 pages between the updated and actual page counts."
              type="error"
              icon={<AlertIcon />}
              showIcon
              closable
            />
          </div>
          {renderFileUpload()}
        </div>
      );
    }

    if (props.isbn) {
      return (
        <div className="book-slider-content">
          <div className="book-slider-img-container">
            <img src={props.imageSrc} alt="Book Cover" />
          </div>
          <div className="book-slider-badge">
            <div>
              BID: <span>{props?.bid}</span>
            </div>
            <div>
              ISBN: <span>{props?.isbn}</span>
            </div>
          </div>
        </div>
      );
    }

    return <NoDataBlock />;
  };

  const drawerTitle =
    props.mode === "batch"
      ? `Book listed for the batch processing (${String(
          props.batchData.length
        ).padStart(2, "0")})`
      : props.bookTitle;

  return (
    <Drawer
      title={drawerTitle}
      placement={props.placement}
      onClose={props.onClose}
      open={props.visible}
      width={props.width}
      className={props.className}
      closeIcon={<CloseCircleOutlined />}
      extra={
        <Space>
          <div className="relative">
            {!props.bookscover && (
              <div className="grid-comments-button-container">
                <button className="comments-header-status-notification">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15.15 6.69802L15.5362 6.31182C16.1761 5.67194 17.2135 5.67194 17.8534 6.31182C18.4933 6.95169 18.4933 7.98914 17.8534 8.62902L17.4672 9.01522M15.15 6.69802C15.15 6.69802 15.1983 7.51869 15.9224 8.24282C16.6466 8.96694 17.4672 9.01522 17.4672 9.01522M15.15 6.69802L11.5995 10.2485C11.359 10.489 11.2388 10.6093 11.1354 10.7418C11.0134 10.8982 10.9088 11.0675 10.8235 11.2465C10.7511 11.3983 10.6974 11.5596 10.5898 11.8823L10.2455 12.9152L10.1341 13.2494M17.4672 9.01522L13.9167 12.5657C13.6762 12.8062 13.556 12.9265 13.4234 13.0299C13.267 13.1519 13.0978 13.2564 12.9187 13.3418C12.767 13.4141 12.6056 13.4679 12.283 13.5754L11.25 13.9198L10.9158 14.0312M10.9158 14.0312L10.5816 14.1426C10.4228 14.1955 10.2478 14.1542 10.1294 14.0358C10.0111 13.9175 9.96976 13.7424 10.0227 13.5836L10.1341 13.2494M10.9158 14.0312L10.1341 13.2494"
                      stroke="#002449"
                    />
                    <path
                      d="M6.66797 10.8319H8.7513"
                      stroke="#002449"
                      strokeLinecap="round"
                    />
                    <path
                      d="M6.66797 7.49988H12.0846"
                      stroke="#002449"
                      strokeLinecap="round"
                    />
                    <path
                      d="M6.66797 14.1678H7.91797"
                      stroke="#002449"
                      strokeLinecap="round"
                    />
                    <path
                      opacity="0.5"
                      d="M2.5 8.33451C2.5 5.19182 2.5 3.62047 3.47631 2.64416C4.45262 1.66785 6.02397 1.66785 9.16667 1.66785H10.8333C13.976 1.66785 15.5474 1.66785 16.5237 2.64416C17.5 3.62047 17.5 5.19182 17.5 8.33451V11.6678C17.5 14.8105 17.5 16.3819 16.5237 17.3582C15.5474 18.3345 13.976 18.3345 10.8333 18.3345H9.16667C6.02397 18.3345 4.45262 18.3345 3.47631 17.3582C2.5 16.3819 2.5 14.8105 2.5 11.6678V8.33451Z"
                      stroke="#002449"
                    />
                  </svg>
                </button>
                <span className="comments-header-status-notification-count">
                  {props?.commentsCount < 10
                    ? "0" + props?.commentsCount
                    : props?.commentsCount}
                </span>
              </div>
            )}
          </div>
        </Space>
      }
    >
      {renderBodyContent()}
    </Drawer>
  );
};

SliderUI.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  bookTitle: PropTypes.string,
  placement: PropTypes.oneOf(["right", "left", "top", "bottom"]),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  mode: PropTypes.string,
  batchData: PropTypes.arrayOf(
    PropTypes.shape({
      bid: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      isbn: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      title: PropTypes.string,
      bookCoverImageURL: PropTypes.string,
    })
  ),
  bookscover: PropTypes.bool,
  fileUpload: PropTypes.bool,
  isbn: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  bid: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  imageSrc: PropTypes.string,
  commentsList: PropTypes.arrayOf(
    PropTypes.shape({
      userName: PropTypes.string,
      comments: PropTypes.string,
      createdOn: PropTypes.string,
    })
  ),
  commentsCount: PropTypes.number,
  form: PropTypes.shape({
    comments: PropTypes.string,
  }),
  setForm: PropTypes.func,
  saveComment: PropTypes.func,
  load: PropTypes.bool,
};

SliderUI.defaultProps = {
  bookTitle: "",
  placement: "right",
  width: 500,
  className: "",
  mode: "",
  batchData: [],
  bookscover: false,
  fileUpload: false,
  isbn: "",
  bid: "",
  imageSrc: "",
  commentsList: [],
  commentsCount: 0,
  form: { comments: "" },
  setForm: undefined,
  saveComment: undefined,
  load: false,
};

export default SliderUI;